export type HeroProps = {
  onSubmitIdea: () => void
}

export const Hero = ({ onSubmitIdea }: HeroProps): JSX.Element => (
  <section className="border-b border-dune-border bg-white">
    <div className="mx-auto w-full max-w-5xl px-4 py-12 sm:px-8 sm:py-16">
      <p className="font-display text-xs uppercase tracking-[0.18em] text-dune-accent">
        Roadmap público
      </p>

      <h1 className="mt-3 max-w-2xl font-display text-3xl font-light tracking-tight text-dune-text sm:text-[40px] sm:leading-[1.1]">
        Construa o futuro da Hodle com a gente
      </h1>

      <p className="mt-4 max-w-xl text-base text-dune-text-secondary">
        Vote nas funcionalidades sugeridas ou envie novas ideias. Seu feedback
        ajuda a definir nossas próximas entregas.
      </p>

      <button
        type="button"
        onClick={onSubmitIdea}
        className="mt-6 w-full rounded-2xl border border-dune-border bg-dune-bg px-5 py-4 text-left font-sans text-sm text-dune-text-secondary transition-colors hover:border-dune-accent sm:max-w-xl"
      >
        Qual funcionalidade falta para você usar ainda mais a Hodle?
      </button>
    </div>
  </section>
)
